import wishlist from '../utils/_wishlist';

class oPlpGrid extends HTMLDivElement {
    constructor() {
        super();
        this.inited = false;
        // bind this
        this.initUrlUpdates = this.initUrlUpdates.bind(this);
        this.addPageUrl = this.addPageUrl.bind(this);
    }

    connectedCallback() {
        document.addEventListener('oPlpGrid:initUrlUpdate', this.initUrlUpdates);
        document.addEventListener('oPlpGrid:addPageUrl', this.addPageUrl);

        wishlist.activateWishlistHeartButtons(); // Activate wishlist button for new loaded products

        const returnToPid = sessionStorage.getItem('returnToPid');
        const returnToPidPLP = sessionStorage.getItem('returnToPidPLP');
        const isSamePLP = returnToPidPLP ? returnToPidPLP === window.location.pathname : false;

        if (returnToPid && isSamePLP && document.querySelector('#plp-container-ajax')) {
            const targetInterval = setInterval(() => { // checks if the element is finally in the DOM
                const targetElement = document.querySelector(`[data-pid="${returnToPid}"]`);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                clearInterval(targetInterval);
            }, 200);

            setTimeout(() => clearInterval(targetInterval), 5000);
        }
        sessionStorage.removeItem('returnToPid');
        sessionStorage.removeItem('returnToPidPLP');
    }

    disconnectedCallback() {
        document.removeEventListener('oPlpGrid:initUrlUpdate', this.initUrlUpdates);
        document.removeEventListener('oPlpGrid:addPageUrl', this.addPageUrl);
    }

    initUrlUpdates(e) {
        if (e && e.detail && e.detail.pageNumber) {
            // init the grid a currentPage -1 in case of loadPrevious triggered the event
            this.dataset.currentPage = e.detail.pageNumber;
        } else {
            // init the grid at page currentPage level
            const urlParams = new URLSearchParams(window.location.search);
            const currentPage = urlParams.get('page');

            if (!currentPage) {
                this.dataset.currentPage = '1';
            } else {
                this.dataset.currentPage = currentPage;
            }
        }

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };
        const observer = new IntersectionObserver((entries) => { this.intersectionCallback(entries); }, options);
        const productTiles = document.querySelectorAll('[is="m-product-tile"]');

        for (const tile of productTiles) {
            observer.observe(tile);
        }

        this.inited = true;
    }

    intersectionCallback(entries) {
        if (entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const elem = entry.target;
                    // filter tiles that are not :
                    // 1) Intersecting
                    // 2) on first columns to prevent multiples changes
                    // 3) are already the same active currentPage
                    if (entry.isIntersecting
                        && entry.intersectionRatio >= 0.5
                        && elem.dataset.currentPage !== this.dataset.currentPage) {
                        // Reset active page on plp-grid element
                        this.dataset.currentPage = elem.dataset.currentPage;
                        // Trigger the url Change
                        this.changePageUrl(this.dataset.currentPage);
                    }
                }
            });
        }
    }

    addPageUrl(event) {
        if (event && event.detail && event.detail.pageNumber && event.detail.pageUrl) {
            const currentUrlDataAttr = `pageUrl-${event.detail.pageNumber}`;
            this.dataset[currentUrlDataAttr] = event.detail.pageUrl;
        }
    }

    changePageUrl(pageNumber) {
        window.history.pushState({}, '', this.dataset[`pageUrl-${pageNumber}`]);
    }
}

customElements.define('o-plp-grid', oPlpGrid, {
    extends: 'div',
});
